export const QuizConfetti = () => (
	<div className="pointer-events-none absolute -inset-2 z-[1] scale-[0.88] overflow-visible md:-inset-4 md:scale-90" aria-hidden>
		{[
			{ top: '2%', left: '6%', color: '#FFD24C', w: 8, h: 8, round: true, delay: '0s' },
			{ top: '8%', right: '4%', color: '#1B81DC', w: 6, h: 6, round: true, delay: '0.4s' },
			{ top: '20%', left: '-2%', color: '#FF6B6B', w: 5, h: 11, round: false, rotate: 25, delay: '0.8s' },
			{ top: '16%', right: '8%', color: '#FFD24C', w: 6, h: 6, round: true, delay: '1.1s' },
			{ top: '42%', left: '2%', color: '#BEDCF9', w: 4, h: 10, round: false, rotate: -18, delay: '0.2s' },
			{ top: '48%', right: '-1%', color: '#349628', w: 7, h: 7, round: true, delay: '0.6s' },
			{ top: '68%', left: '10%', color: '#1B81DC', w: 5, h: 5, round: true, delay: '1.4s' },
			{ top: '72%', right: '10%', color: '#FFD24C', w: 4, h: 9, round: false, rotate: 40, delay: '0.9s' },
			{ top: '88%', left: '20%', color: '#FF6B6B', w: 6, h: 6, round: true, delay: '1.7s' },
			{ top: '90%', right: '16%', color: '#BEDCF9', w: 6, h: 6, round: true, delay: '0.5s' }
		].map((piece, i) => (
			<span
				key={i}
				className="absolute animate-[confetti-float_3s_ease-in-out_infinite]"
				style={{
					top: piece.top,
					left: piece.left,
					right: piece.right,
					width: piece.w,
					height: piece.h,
					backgroundColor: piece.color,
					borderRadius: piece.round ? '9999px' : '2px',
					transform: piece.rotate ? `rotate(${piece.rotate}deg)` : undefined,
					animationDelay: piece.delay
				}}
			/>
		))}
		<img
			src={require('@/assets/icons/gift.png')}
			alt=""
			className="absolute left-[4%] top-[30%] h-5 w-5 opacity-80 md:h-6 md:w-6 animate-[confetti-float_2.8s_ease-in-out_infinite]"
			style={{ animationDelay: '0.3s' }}
		/>
		<img
			src={require('@/assets/icons/stars.png')}
			alt=""
			className="absolute right-[6%] top-[34%] h-4 w-4 opacity-90 md:h-6 md:w-6 animate-[confetti-float_3.2s_ease-in-out_infinite]"
			style={{ animationDelay: '0.7s' }}
		/>
		<span
			className="absolute left-[14%] top-[56%] text-sm md:text-lg animate-[confetti-float_2.6s_ease-in-out_infinite]"
			style={{ animationDelay: '1s' }}
		>
			🎉
		</span>
		<span
			className="absolute right-[14%] top-[60%] text-xs md:text-base animate-[confetti-float_3.4s_ease-in-out_infinite]"
			style={{ animationDelay: '0.15s' }}
		>
			✨
		</span>
		<style>{`
			@keyframes confetti-float {
				0%, 100% { transform: translateY(0) rotate(0deg); opacity: 0.85; }
				50% { transform: translateY(-10px) rotate(8deg); opacity: 1; }
			}
		`}</style>
	</div>
)
